import axios from "../auth/FetchInterceptor";

export const getAllAnnouncements = async (queryString) => {
  const response = await axios.get(`/announcements?${queryString}`);
  return response;
};

export const createAnnouncement = async (data) => {
  const response = await axios.post("/announcements", data);
  return response.data;
};
export const getOne = async (id) => {
  const response = await axios.get(`/announcements/${id}`);
  return response.data;
};
export const uploadMediaService = async (formData) => {
  const response = await axios.post("/announcements/upload/media", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  console.log(response.data);
  return response.data;
};

export const updateAnnouncement = async (id, data) => {
  const response = await axios.put(`/announcements/${id}`, data);
  return response.data;
};

export const updateAnnouncementStatus = async (id, status) => {
  const response = await axios.put(`/announcements/${id}/status`, { status });
  return response.data;
};

export const deleteAnnouncement = async (id) => {
  const response = await axios.delete(`/announcements/${id}`);
  return response.data;
};
